import React, { useEffect, useMemo, useState } from 'react'
import Card from 'react-bootstrap/Card';
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import CustomersForm from './CustomersForm';
import { useHistory } from 'react-router';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import Button from 'react-bootstrap/esm/Button';
import Loading from '../../Components/Layout/Styled/Loading';
import Select from '../../Components/Form/Select';
import SwitchToggle from '../../Components/Form/SwitchToggle';


const FormKit = ({ branchOffices, products, idTypeMoney, idCustomers, setShowLoading, setLoadSubmit }) => {
    const [idBranchOffice, setidBranchOffice] = useState('')
    const [pickUp, setPickUp] = useState(false)

    const cboBranchOffice = useMemo(() => {
        if (!idBranchOffice) {
            return
        }

        let finded = branchOffices.find(t => parseInt(t.id_branch_office) === parseInt(idBranchOffice))

        if (!finded) {
            return
        }

        return {
            label: finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [idBranchOffice, branchOffices])

    return <>

        {<div className=''>
            <div className='form-row mt-4'>
                <div className="col-12">
                    <SwitchToggle
                        classNameParent="col-12 mb-2"
                        id="checkbox_pick_up_branch_office"
                        checked={pickUp}
                        textCheck="¿Recoger en Sucursal?"
                        textUnChecked="¿Recoger en Sucursal?"
                        onChange={e => {
                            setPickUp(e.currentTarget.checked)
                        }}
                    />
                </div>
                {pickUp && <>
                    <div className="col-md-3"></div>
                    <Select
                        text="Sucursal"
                        options={branchOffices.map(b => {
                            return {
                                label: b.name_branch_office,
                                value: b.id_branch_office
                            }
                        })}
                        value={cboBranchOffice}
                        onChange={e => {
                            Controllers.branch_office.get_branch_office_tax_shipping({
                                p_id_branch_office: e.value,
                            }).then(_ => {
                                setidBranchOffice(e.value)
                            })
                        }}
                        classNameParent="col-md-6 mb-2"
                    />
                </>}
            </div>

            <div className="form-row mt-4">
                {React.Children.toArray([
                    ...products.data,
                ].map(r => {
                    return <div className="col-xl-6">
                        <div className='p-1 p-lg-4'>
                            <div className="d-flex flex-column p-4 shadow">
                                <div className="d-flex justify-content-center" style={{
                                }}>
                                    <img src={Helpers.config.resourcesUrl({ url: r.file_photo })} alt="" className="img-fluid mb-2 align-self-center" style={{ width: 190, maxHeight: 300 }} />
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="align-self-center d-flex flex-column">
                                        <strong className="mt-">{r.description_store_product}</strong>
                                        <strong className="mt-">$ {r.price_product}</strong>
                                        <small className="mt-">Puntos {r.point_product}</small>
                                        <small className="mt-">Valor Negocio {r.value_business_product}</small>
                                    </div>
                                    <div className="align-self-center ml-4">
                                        <Button size="sm" variant={'outline-primary'} onClick={_ => {
                                            console.log('pickUp', pickUp )
                                            console.log('idBranchOffice', idBranchOffice)
                                            
                                            if (pickUp && !idBranchOffice) {
                                                Helpers.toast.construct({
                                                    response: 'warning',
                                                    message: 'Seleccione una sucursal',
                                                    toast
                                                })
                                                return false;
                                            }

                                            setShowLoading(true)
                                            Controllers.customers.pay_kit_customers({
                                                p_id_customers: idCustomers,
                                                p_id_kit: r.id_product,
                                                p_id_branch_office: idBranchOffice
                                            }).then(res => {
                                                if (res.response !== 'success') {
                                                    Helpers.toast.construct({ ...res, toast })
                                                    setShowLoading(false)
                                                    return
                                                }
                                                setShowLoading(false)
                                                window.location.href = res.data.link_pay
                                            }).catch(req => Helpers.promise.catch({ req, toast }))
                                                .finally(() => {
                                                    setLoadSubmit(false)
                                                })
                                        }}>
                                            <i className="fa fa-shopping-cart"></i>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                    </div>
                }))}
            </div>
        </div>}
    </>
}

const SaveMyCustomers = () => {
    const [loadSubmit, setLoadSubmit] = useState(false)
    const history = useHistory()
    const [showPassword, setShowPassword] = useState(false);
    const [contentPassword, setContentPassword] = useState('');
    const [showLoading, setShowLoading] = useState(false)

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.customers.customers_insert_update(data).then(res => {
            console.log('res insert update', res);
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {

                Promise.all([
                    Controllers.customers_publico.get_product_for_customers_new({
                        p_id_country: parseInt(res.data.id_type_money) === 2 ? 1 : 2
                    }),
                    Controllers.branch_office.get_branch_office_without_laboratory(),
                ]).then(([resProducts, resBranchOffice]) => {
                    setContentPassword(<>
                        <div className="d-flex justify-content-center flex-column align-items-center">
                            <div>Usuario: <strong>{res.data.id}</strong></div>
                            <div>Contraseña: <strong>{res.data.password}</strong></div>
                        </div>
                        <FormKit
                            products={resProducts}
                            branchOffices={resBranchOffice.data.filter(b => {
                                return parseInt(b.id_type_money) === parseInt(res.data.id_type_money)
                            })}
                            idTypeMoney={res.data.id_type_money}
                            idCustomers={res.data.id}
                            setShowLoading={setShowLoading}
                            setLoadSubmit={setLoadSubmit}
                        />
                    </>)
                    setShowPassword(true)
                })
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
            })
    }

    useEffect(() => {
        /* const res = {
            data: {
                id: '31750',
                password: '123456',
                id_type_money: 2,

            }
        }

        Promise.all([
            Controllers.customers_publico.get_product_for_customers_new({
                p_id_country: parseInt(res.data.id_type_money) === 2 ? 1 : 2
            }),
            Controllers.branch_office.get_branch_office_without_laboratory(),
        ]).then(([resProducts, resBranchOffice]) => {
            setContentPassword(<>
                <div className="d-flex justify-content-center flex-column align-items-center">
                    <div>Usuario: <strong>{res.data.id}</strong></div>
                    <div>Contraseña: <strong>{res.data.password}</strong></div>
                </div>
                <FormKit
                    products={resProducts}
                    branchOffices={resBranchOffice.data.filter(b => {
                        return parseInt(b.id_type_money) === parseInt(res.data.id_type_money)
                    })}
                    idTypeMoney={res.data.id_type_money}
                    idCustomers={res.data.id}
                    setShowLoading={setShowLoading}
                    setLoadSubmit={setLoadSubmit}
                />
            </>)
            setShowPassword(true)
        }) */
    }, [])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Registrar Cliente</span>
            </Card.Header>
            <Card.Body>
                <CustomersForm onSubmit={handleInsertUpdate} saveMyCustomers loadSubmit={loadSubmit} />
            </Card.Body>
        </Card>
        <SweetAlert
            icon="info"
            show={showPassword}
            showCancelButton
            title={'Datos del registro'}
            cancelButtonText={'Ok'}
            onCancel={_ => {
                history.push(Helpers.config.convertUrl({ url: '/descendia-de-red' }))
            }}
            content={_ => {
                return <>
                    {contentPassword}
                </>
            }}
            modalSize="xl"
        />
        <Loading show={showLoading}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
    </>
}

export default SaveMyCustomers